import OnlineSalesOrder from '../../../../components/Sales/Orders/OnlineSalesOrder/OnlineSalesOrder'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import React from 'react'

function OnlineSalesOrderCont(props) {
  const { data, fetching, fetchURL: fetch } = useFetchURL(`https://orders.mmeagroup.com/api/order/`)

  const {
    visible,
    onShow,
    onCancel,
    payload: { object: line = {} },
  } = useModalShow()

  return <OnlineSalesOrder {...{ data, fetching, fetch, visible, onShow, onCancel, line }} />
}

export default OnlineSalesOrderCont
